import { action, computed, observable } from 'mobx'
import { LoginMethod } from '../models/enums/LoginMethod'
import RootStore from './RootStore'

interface IUser {
	id: number
	companyId: number
	email: string
	firstName: string
	lastName: string
	phoneNumber: string
	language: string
	roles: Array<IRole>
	loginType: LoginMethod
}

interface IRole {
	role: string
}

export class UserStore {
	@observable public user: IUser = {
		companyId: -1,
		id: -1,
		email: '',
		firstName: '',
		lastName: '',
		phoneNumber: '',
		language: '',
		roles: [],
		loginType: LoginMethod.Password,
	}
	@observable public languageSettings: { language: string } = { language: 'English' }

	@computed get name() {
		return [this.user?.firstName, this.user?.lastName].filter(Boolean).join(' ')
	}

	@computed get firstName() {
		return this.user?.firstName
	}

	@computed get userId() {
		return this.user?.id
	}

	constructor(rootStore: RootStore) {
		this.resetUser()
	}

	@action resetUser() {
		this.user = {
			companyId: -1,
			id: -1,
			email: '',
			firstName: '',
			lastName: '',
			phoneNumber: '',
			language: '',
			roles: [],
			loginType: LoginMethod.Password
		}

		this.languageSettings.language = this.user.language;
	}

	@action updateUser(userInfo?: any) {
		this.user = {
			companyId: userInfo.companyId,
			id: userInfo.id,
			email: userInfo.email,
			firstName: userInfo.firstName,
			lastName: userInfo.lastName,
			phoneNumber: userInfo.phoneNumber,
			language: userInfo.language,
			roles: userInfo.roles,
			loginType: userInfo.loginType
		}
		this.languageSettings.language = this.user.language;
	}
}
